import { z } from "zod";
import { basicQuestionSchema } from "../../client/client.js";
import { multilineContentSchema } from "../../content/schema.js";
import {
  checkIsVoiceInterviewSectionType,
  InterviewSectionType,
  interviewSectionTypeSchema
} from "./types.js";
const baseInterviewSectionSettingsSchema = z.object({
  type: interviewSectionTypeSchema
});
const questionsInterviewSectionSettingsSchema = z.intersection(
  baseInterviewSectionSettingsSchema,
  z.object({
    type: z.literal(InterviewSectionType.Questions)
  })
);
const rolePlayInterviewSectionSettingsSchema = z.intersection(
  baseInterviewSectionSettingsSchema,
  z.object({
    type: z.literal(InterviewSectionType.RolePlay),
    /** Title of the section to help distinguish role play sections. */
    title: z.string().optional(),
    participant_instructions: multilineContentSchema,
    agent_instructions: multilineContentSchema
  })
);
const knowledgeTestInterviewSectionSettingsSchema = z.intersection(
  baseInterviewSectionSettingsSchema,
  z.object({
    type: z.literal(InterviewSectionType.KnowledgeTest),
    title: z.string().optional(),
    questions: z.array(basicQuestionSchema),
    /** LLM-generated context with answers to the questions, derived from the playbook's knowledge base. */
    answers_context: z.string().optional()
  })
);
const chatQuizInterviewSectionSettingsSchema = z.intersection(
  baseInterviewSectionSettingsSchema,
  z.object({
    type: z.literal(InterviewSectionType.ChatQuiz),
    topic: z.string(),
    questions: z.array(basicQuestionSchema),
    /** LLM-generated context with answers to the questions, derived from the playbook's knowledge base. */
    answers_context: z.string().optional()
  })
);
const interviewSectionSettingsSchema = z.union([
  questionsInterviewSectionSettingsSchema,
  rolePlayInterviewSectionSettingsSchema,
  knowledgeTestInterviewSectionSettingsSchema,
  chatQuizInterviewSectionSettingsSchema
]);
function checkIsVoiceInterviewSectionSettings(settings) {
  return checkIsVoiceInterviewSectionType(settings.type);
}
export {
  checkIsVoiceInterviewSectionSettings,
  interviewSectionSettingsSchema
};
//# sourceMappingURL=settings.js.map
